import { useNavigate } from 'react-router-dom';
import { getBusinessId } from './Api';

export function getBusinessUrl(to) {
    return `/business/${getBusinessId()}${to}`;
}

export default function () {
    const navigate = useNavigate();

    return function (to, options) {
        navigate(getBusinessUrl(to), options);
    };
}
